export const DEFAULT_LOCALE = 'en-us';

// Локали, доступные на www. В whitelabel-сборках на поддоменах набор произвольный
export const WWW_LOCALES: string[] = ['en-us', 'en-ae'];

// Префикс локали в начале пути: /en-ae, /en-ae/avia, /ru/
export const LOCALE_PATH_PAT = /^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/;
